module.exports = __webpack_public_path__ + "static/img/s105.007fef87.png";